import dayjs from 'dayjs';

/** BridgeGate web app root (e.g. http://localhost:8080/bridgegate). */
export function resolveBridgegateRoot(baseUrl) {
  const raw = String(baseUrl ?? '').trim().replace(/\/$/, '');
  if (raw) {
    if (/\/bridgegate$/i.test(raw)) return raw;
    try {
      const { origin } = new URL(raw);
      return `${origin}/bridgegate`;
    } catch {
      return `${raw}/bridgegate`;
    }
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/bridgegate`;
  }
  return '';
}

/** Transaction Search JSP expects slash-separated dates (yyyy/MM/dd). */
export function formatTxnSearchDate(value) {
  if (!value) return '';
  return dayjs(value).format('YYYY/MM/DD');
}

/**
 * Hidden form fields for txn_list.jsp Filter POST (testable without DOM submit).
 * Uses startDateStr/endDateStr/ipAddress — never startDate/endDate/source.
 */
export function buildTransactionSearchFormFields({
  account,
  workflowGroup,
  workflowName,
  startDate,
  endDate,
  source,
}) {
  if (!account) return null;

  const fields = [];
  const add = (name, value) => {
    if (value == null || value === '') return;
    fields.push({ name, value: String(value) });
  };

  add('accountName', account);
  add('wfGroup', workflowGroup);
  add('wfName', workflowName);
  if (startDate) add('startDateStr', `${formatTxnSearchDate(startDate)} 00:00`);
  if (endDate) add('endDateStr', `${formatTxnSearchDate(endDate)} 23:59`);
  add('ipAddress', source);
  add('MODE', 'FILTER');
  add('qty', '50');

  return fields;
}

/** Mimics txn_list.jsp Filter POST — opens filtered results in a new tab. */
export function submitTransactionSearch(
  baseUrl,
  { account, workflowGroup, workflowName, startDate, endDate, source }
) {
  const root = resolveBridgegateRoot(baseUrl);
  const fields = buildTransactionSearchFormFields({
    account,
    workflowGroup,
    workflowName,
    startDate,
    endDate,
    source,
  });
  if (!root || !fields?.length) return;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${root}/ops/txn/search`;
  form.target = '_blank';

  fields.forEach(({ name, value }) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  form.remove();
}
